export function trackEvent(
    category: string,
    action: string,
    label?: string,
    value?: string,
) {
    const { dataLayer } = window

    if (!dataLayer || !dataLayer.push) {
        return
    }

    const event = {
        event: 'Event',
        action,
        category,
        label,
        value,
    }

    dataLayer.push(event)
}
